var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9412 0H10.0588L17.7059 9.5L10.0588 19H16.9412L24.5882 9.5L16.9412 0Z",
    fill: "#37A0F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82353 1.11768H0L6.47058 9.50002L0 17.8824H5.82353L12.2941 9.50002L5.82353 1.11768Z",
    fill: "#37A0F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleRight);
export default __webpack_public_path__ + "static/media/double_right.bb50d9ec3bf49fdee5bf32660bb801fa.svg";
export { ForwardRef as ReactComponent };